import classNames from "classnames/bind";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CloseIcon, DeleteIcon, ErrorIcon, GotoMore, SuccessIcon } from "../../../../components/Icons/Icons";
import styles from './ServicesRegisted.module.css';
import { Alert, Switch, Table } from "../../../../components";

const cx = classNames.bind(styles);

function TableListService({ handleShowListCamera, listPackRegistered }) {
    const [listPack, setListPack] = useState()
    const [isDelete, setIsDelete] = useState(false)

    useEffect(() => {
        setListPack(listPackRegistered)
    }, [listPackRegistered])

    const handleDeletService = () => {
        setIsDelete(!isDelete)
    }
    const handleAdd = () => {
        setIsDelete(!isDelete)
    }
    const handleClose = () => {
        setIsDelete(!isDelete)
    }

    const data = [
        {
            stt: 1,
            namService: 'Phát hiện chuyển động',
            resolution: '360p',
            timeSaveRecord: 14,
            timeStart: '22/02/2024',
            autoReNew: true,
            totalPrice: '1000 VND',
            status: 'cancel'
        },
        {
            stt: 3,
            namService: 'Phát hiện chuyển động',
            resolution: '360p',
            timeSaveRecord: 14,
            timeStart: '22/02/2024',
            autoReNew: true,
            totalPrice: '1000 VND',
            status: 'pending'
        },
    ]

    const listStatus = [
        {
            code: 'pending',
            mesage: <span className={cx('tag')}>
                <SuccessIcon />
                <p className={cx('label', 'success')}>Đang sử dụng</p>
            </span>
        },
        {
            code: 'cancel',
            mesage: <span className={cx('tag')}>
                <CloseIcon />
                <p className={cx('label', 'cancel')}>Hết hạn</p>
            </span>
        },
    ]

    const dataSource = data.map((item, index) => {
        return {
            stt: item.stt,
            namService: item.namService,
            resolution: item.resolution,
            timeSaveRecord: item.timeSaveRecord,
            timeStart: item.timeStart,
            autoReNew: <div className={cx('auto_renew')}><Switch type="small" value={item.autoReNew} disable /></div>,
            totalPrice: <div className={cx('count-camera')} onClick={() => handleShowListCamera(item.SUBJECT_NAME)}>
                <GotoMore />
                <p className={cx('label')}>16 Camera</p>
            </div>,
            status: listStatus.find(st => st.code === item.status).mesage,
            action: <div className={cx('auto_renew')}>
                {item.status === 'pending' && <button onClick={handleDeletService}><DeleteIcon /></button>}
            </div>
        }
    })

    const columns = [
        {
            label: <div className={cx('center')} style={{ width: '40%' }}>STT</div>,
            key: "stt",
        },
        {
            label: 'Tên dịch vụ',
            key: "namService",
        },
        {
            label: "Chất lượng hình ảnh",
            key: "resolution",
        },
        {
            label: 'Thời gian lưu trữ',
            key: "timeSaveRecord",
        },
        {
            label: 'Thời gian bắt đầu',
            key: "timeStart",
        },
        {
            label: 'Gia hạn/ tự động gia hạn',
            key: "autoReNew",
        },
        {
            label: 'Số Camera',
            key: "totalPrice",
        },
        {
            label: 'Trạng thái',
            key: "status",
        },
        {
            label: '',
            key: "action",
        },
    ];
    return (
        <>
             {isDelete && (
                <Alert
                    type="alert"
                    title="Bạn có muốn huỷ đăng ký dịch vụ này không"
                    onClose={handleClose}
                    onOk={handleAdd}
                />
            )}
            <Table colum={columns} data={dataSource} />
        </>

    )
}

export default TableListService;